// extracted by mini-css-extract-plugin
export default {"section":"styles_section__bm-U1","largeSection":"styles_largeSection__HsAub"};